import { useEffect } from 'react'
import { useAtom } from 'jotai'
import { Box, Dialog, DialogContent, Typography, Divider, Link } from '@mui/material'

import { DialogHeader } from '../../components/ui'
import { RequestTrackingByOrderResponse, RequestTrackingByChildrenResponse } from '../../types/tracking'
import { childrenOrdersErrorsOpenState } from '../../state'

//import DEFAULT from '../../config/default'

//const countryCode: string | undefined = DEFAULT.api.countryCode

interface ChildrenOrdersProps {
    children?: RequestTrackingByChildrenResponse,
    parent: RequestTrackingByOrderResponse,
}

const TrackingChildrenErrors = ({ children, parent }: ChildrenOrdersProps) => {
    const [open, setOpen] = useAtom(childrenOrdersErrorsOpenState)

    console.log(children);
    console.log(parent);

    useEffect(() => {
        if (children?.listPedido.some((e) => e.eventoTipoFinalizacionTracking)) {
            setOpen(true)
        }
    }, [children, setOpen])

   if  (!children) return null

    // ROBO: 12
    // DAÑO: 13
    // DEVUELTO A ORIGEN: 6
    
    return (
        children ? (
            <Dialog open={open} maxWidth="md" onClose={() => setOpen(false)}>
                <DialogHeader id="order-status-list" onClose={() => setOpen(false)}>
                    <span>
                        Información del pedido
                    </span>
                </DialogHeader>
                <DialogContent dividers>
                    <Typography variant="body2"></Typography>
                    { children.listPedido.map((order, index) => {
                        if (order.idEvento === 12) {
                            return (
                                <>
                                    <Box key={index} sx={{ marginTop: 2 }}>
                                        <Typography variant="body2">
                                            <strong>Caja</strong> {index+1}/{children.listPedido.length}
                                        </Typography>
                                        <Typography variant="body2">
                                            Lamentablemente tuvimos un inconvenitente con tu pedido. 
                                            <br/>
                                            { order.idPedidoReemplazante ? (
                                                <>Generamos el pedido <Link href={`/#/pedido/${order.idPedidoReemplazante}`} target="_blank" underline="hover">{ order.idPedidoReemplazante }</Link> el cual será surtido y enviado en breve.</>
                                            ) : (
                                                <>A la brevedad generaremos un nuevo pedido.</>
                                            )}
                                        </Typography>
                                    </Box>
                                    <Divider sx={{ mt: 1, mb: 1 }}/>
                                </>
                            )
                        } else if (order.idEvento === 13) {
                            return (
                                <>
                                    <Box key={index} sx={{ marginTop: 2 }}>
                                        <Typography variant="body2">
                                            <strong>Caja</strong> {index+1}/{children.listPedido.length}
                                        </Typography>
                                        <Typography variant="body2">
                                            Lamentablemente <strong>tu pedido fue devuelto por DAÑO en el empaque</strong>
                                            <br/>
                                            { order.idPedidoReemplazante ? (
                                                <>Generamos el pedido <Link href={`/#/pedido/${order.idPedidoReemplazante}`} target="_blank" underline="hover">{ order.idPedidoReemplazante }</Link> el cual será surtido y enviado en breve</>
                                            ) : (
                                                <>A la brevedad generaremos un nuevo pedido.</>
                                            )}
                                        </Typography>
                                    </Box>
                                    <Divider sx={{ mt: 1, mb: 1 }}/>
                                </>
                            )
                        } else if (order.idEvento === 6) {
                            return (
                                <>
                                    <Box key={index} sx={{ marginTop: 2 }}>
                                        <Typography variant="body2">
                                            <strong>Caja</strong> {index+1}/{children.listPedido.length}
                                        </Typography>
                                        <Typography variant="body2">
                                            Lamentablemente <strong>una de las cajas de tu pedido fue devuelta por DAÑO en el empaque</strong>
                                            <br/>
                                            { order.idPedidoReemplazante ? (
                                                <>Generamos el pedido <Link href={`/#/pedido/${order.idPedidoReemplazante}`} target="_blank" underline="hover">{ order.idPedidoReemplazante }</Link> el cual será surtido y enviado en breve</>
                                            ) : (
                                                <>A la brevedad generaremos un nuevo pedido.</>
                                            )}
                                        </Typography>
                                    </Box>
                                    <Divider sx={{ mt: 1, mb: 1 }}/>
                                </>
                            )
                        } else {
                            return null
                        }
                    })}                    
                </DialogContent>
            </Dialog>
        ) : null
    )
}

export { TrackingChildrenErrors }
